import AsyncStorage from "@react-native-async-storage/async-storage";
import { check, PERMISSIONS, RESULTS } from "react-native-permissions";

// Function for transforming Contact Array to get the desired array
export const transformContactsArray = (contact) => {
  const contacts = JSON.parse(contact);
  let i;
  const contactOutput = [];
  try {
    for (i = 0; i < contacts.length; i++) {
      contacts[i].number &&
        contacts[i].number.length >= 10 &&
        contacts[i].name &&
        contacts[i].name.length != 0 &&
        contactOutput.push({
          user_id: contacts[i].number
            .replace(/[^a-zA-Z0-9]/g, "")
            .replace(/\s+/g, "")
            .slice(-10)
            .trim(),
          user_phone: contacts[i].number
            .replace(/[^a-zA-Z0-9]/g, "")
            .replace(/\s+/g, "")
            .slice(-10),
          user_name: contacts[i].name,
          saved: false,
        });
    }
  } catch (error) {
    console.log(error);
  }
  return contactOutput;
};

// Function for saving json data into async storage
export const saveJsonData = async (key, jsonData) => {
  await AsyncStorage.setItem(key, JSON.stringify(jsonData));
};
// Function for fetching json data into async storage
export const getJsonData = async (key) => {
  return JSON.parse(await AsyncStorage.getItem(key));
};
export const checkConatctPermission = async () => {
  let havePermission = false;
  // Checking for contact permission
  try {
    const permissionType = await check(PERMISSIONS.ANDROID.READ_CONTACTS);
    const permissionStatus = permissionType;
    if (permissionStatus === RESULTS.GRANTED) {
      havePermission = true;
    }
    // Condtion for checking if permission is granted
  } catch (error) {
    console.log(error);
  }
  return havePermission;
};
export const removeDuplicates = (mainArr, duplicate) => {
  mainArr = mainArr.filter(function (cv) {
    return !duplicate.find(function (e) {
      return e.user_phone == cv.user_phone;
    });
  });
  return mainArr;
};

export const removeJson = (key) => {
  try {
    AsyncStorage.removeItem(key);
  } catch (e) {
    console.warn(e);
  }
};
